
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/article/[...slug]",
      function () {
        return require("private-next-pages/[language]/article/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/article/[...slug]"])
      });
    }
  